export const problemKeys = {
  name: "Name",
  defaultTitle: "Default Title",
  description: "Description",
  status: "Status",
  problemReactions: "Problem Reactions",
  problemDifficulties: "Problem Difficulties",
  problemCompanies: "Problem Companies",
  problemTags: "Problem Tags",
};
